import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const mutation = withDefaultMeta(builder.mutation);

    return {
      // 📨 Send contact message
      sendContactMessage: mutation({
        query: (payload) => ({
          url: "/contact",
          method: "POST",
          body: payload,
        }),
      }),
    };
  },
});

export const { useSendContactMessageMutation } = contactApiSlice;
